// extracted by mini-css-extract-plugin
module.exports = {"shadow":"section_shadow__WPIUJ","withRightMenu":"section_withRightMenu__J1Qp7"};